import React from "react";
import classNames from "classnames";

interface MessageBtnProps {
  icon: string;
  title: string;
  disabled?: boolean;
  onClick?: () => void;
  color?: "green" | "blue";
}

const MessageBtn: React.FC<MessageBtnProps> = ({
  icon,
  title,
  onClick,
  disabled,
  color = "green",
}) => {
  const colorClasses = {
    green: {
      background: "bg-greenSoft",
      accent: "bg-positive",
      text: "text-positive",
    },
    blue: {
      background: "bg-primaryLighter",
      accent: "bg-primary",
      text: "text-primary",
    },
  };

  const currentColor = colorClasses[color];

  return (
    <button
      type="button"
      className={classNames(
        "flex h-10 w-full items-center overflow-hidden rounded-lg shadow-sm transition-all duration-200 hover:opacity-90",
        currentColor.background,
        {
          "cursor-not-allowed opacity-50": disabled,
        },
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <div
        className={classNames(
          "flex h-10 w-14 items-center justify-center",
          currentColor.accent,
        )}
      >
        <img src={icon} alt="" className="h-6 w-6" />
      </div>
      <div
        className={classNames("px-4 py-2.5 font-semibold", currentColor.text)}
      >
        {title}
      </div>
    </button>
  );
};

export default MessageBtn;
